import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Companion } from '../_models';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  constructor(private http: HttpClient) {}

  Restaurants(idShip: string) {
    // Initialize Params Object
    let params = new HttpParams();

    // Begin assigning parameters
    params = params.append('id_ship', idShip);

    let url = `${environment.host}${environment.api}/restaurants`;
    return this.http.get<any>(url, { params: params });
  }

  RestaurantSlot(uuid: string, companions: Array<string>) {
    // Initialize Params Object
    let params = new HttpParams();

    // Begin assigning parameters
    params = params.append('uuid_passengers', companions.join(','));

    let url = `${environment.host}${environment.api}/restaurants/${uuid}/slots`;
    return this.http.get<any>(url, { params: params });
  }

  Passengers(uuid: string, uuid_restaurant: string) {
    let url = `${environment.host}${environment.api}/passenger/${uuid}/companions/${uuid_restaurant}`;
    return this.http.get<Array<Companion>>(url);
  }

  SetReservation(data: any) {
    let url = `${environment.host}${environment.api}/reservations`;
    return this.http.post<any>(url, data);
  }
}
